import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { ZoomImage as Original } from 'components/organisms'
import { ZoomImageSettings, ZoomImageFloatingSettings } from './ZoomImageSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { imageDefaultProps } from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/ImageToolbarSection'

export const defaultProps = {
  ...imageDefaultProps(),
}

export const dynamicProps = []

export const ZoomImage: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return enabled ? (
      <div ref={(ref) => props.retRef(ref)} className={`block-zoom-image ${props.className}`}>
        <Original
          image={{
            url: blockProps.src,
            alt: blockProps.alt,
          }}
          editMode={enabled}
        />
      </div>
    ) : (
      <Original
        image={{
          url: blockProps.src,
          alt: blockProps.alt,
        }}
        editMode={enabled}
      />
    )
  },
  defaultProps,
  dynamicProps
)

ZoomImage.craft = withCraft({
  name: 'ZoomImage',
  defaultProps: defaultProps,
  settings: ZoomImageSettings,
  floatingSettings: ZoomImageFloatingSettings,
})
